import axios from 'axios';

const DEV = process.env.NODE_ENV === 'development';

export const BASE_URL = DEV ? 'http://localhost:3002' : 'https://v2.api.corridaperfeita.com';

const coreApi = axios.create({ baseURL: BASE_URL });

export default coreApi;
